// Appointments ki list aur detail dono me lagne wale chhote icons.
// Sab `currentColor` lete hain — rang CSS se.
import React from "react";

const svg = (size, children) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {children}
  </svg>
);

const stroke = { stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };

export const CalendarIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <rect x="4" y="5" width="16" height="15" rx="3" {...stroke} />
      <path d="M8 3v4M16 3v4M4 10h16" {...stroke} />
    </>,
  );

export const ClockIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" {...stroke} />
      <path d="M12 7.5V12l3 2" {...stroke} />
    </>,
  );

export const ChevronIcon = ({ size = 16, down = false }) =>
  svg(size, <path d={down ? "M6 9l6 6 6-6" : "M9 6l6 6-6 6"} {...stroke} />);

export const BackIcon = ({ size = 22 }) => svg(size, <path d="M15 5l-7 7 7 7" {...stroke} />);

export const CheckCircleIcon = ({ size = 16 }) =>
  svg(
    size,
    <>
      <circle cx="12" cy="12" r="9" fill="currentColor" />
      <path d="M8 12.2l2.6 2.6L16 9.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>,
  );

export const CrossCircleIcon = ({ size = 16 }) =>
  svg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" {...stroke} />
      <path d="M9 9l6 6M15 9l-6 6" {...stroke} />
    </>,
  );

export const RefreshIcon = ({ size = 16 }) =>
  svg(
    size,
    <>
      <path d="M20 12a8 8 0 1 1-2.6-5.9" {...stroke} />
      <path d="M20 4v5h-5" {...stroke} />
    </>,
  );

export const AlertIcon = ({ size = 16 }) =>
  svg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" {...stroke} />
      <path d="M12 8v4.5M12 16h.01" {...stroke} />
    </>,
  );

export const PhoneIcon = ({ size = 18 }) =>
  svg(
    size,
    <path
      d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z"
      {...stroke}
    />,
  );

export const VideoIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <rect x="3" y="6.5" width="12" height="11" rx="2.5" {...stroke} />
      <path d="M15 10.5l6-3v9l-6-3" {...stroke} />
    </>,
  );

export const DocIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <path d="M7 3h7l4 4v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" {...stroke} />
      <path d="M9 12h6M9 16h6" {...stroke} />
    </>,
  );

export const MailIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" {...stroke} />
      <path d="M3.5 7l8.5 6 8.5-6" {...stroke} />
    </>,
  );

export const BuildingIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <rect x="5" y="3" width="14" height="18" rx="2" {...stroke} />
      <path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M10 21v-4h4v4" {...stroke} />
    </>,
  );

export const SourceIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <circle cx="11" cy="11" r="7" {...stroke} />
      <path d="M16.5 16.5L21 21" {...stroke} />
    </>,
  );

export const GlobeIcon = ({ size = 18 }) =>
  svg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" {...stroke} />
      <path d="M3.5 12h17M12 3.5c2.5 2.6 2.5 14.4 0 17M12 3.5c-2.5 2.6-2.5 14.4 0 17" {...stroke} />
    </>,
  );

export const SparkIcon = ({ size = 18 }) =>
  svg(size, <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" {...stroke} />);

export const TYPE_ICONS = { video: VideoIcon, phone: PhoneIcon, doc: DocIcon };

export const BADGE_ICONS = {
  check: CheckCircleIcon,
  cross: CrossCircleIcon,
  refresh: RefreshIcon,
  clock: ClockIcon,
};
